import { createContext } from 'react'

/** Group context: only one swipeable item is open at a time. */
export const SwipeableGroupContext = createContext<{
  openId: string | null
  setOpenId: (id: string | null) => void
}>({ openId: null, setOpenId: () => {} })
